import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface TivityLogoProps {
    variant?: 'light' | 'dark';
    size?: number;
}

// The generic Tivity wordmark, used everywhere a club's own logo isn't
// applicable (nav bars, auth pages) -- rendered rather than a static image
// so it never accidentally becomes tied to one specific club's branding.
function TivityLogo({ variant = 'dark', size = 32 }: TivityLogoProps) {
    const color = variant === 'light' ? '#fff' : 'primary.main';

    return (
        <Box display="flex" alignItems="center" sx={{ color }}>
            <Typography
                variant="h5"
                component="span"
                letterSpacing={0.5}
                sx={{ color: 'inherit', lineHeight: 1, fontSize: size, fontFamily: '"Righteous", sans-serif' }}
            >
                Tivity
            </Typography>
        </Box>
    );
}

export default TivityLogo;
